import { useEffect } from 'react'
import { Button, Loading } from 'components'
import { useAccountActions } from 'hooks/userHooks'
import { noop } from 'utils'
import { UserType } from 'types'
export type ReactivateTMATTBtnProps = {
  userId: string
  disabled?: boolean
  userType?: UserType
  onDone?: (message: string) => void
  onError?: (message: string) => void
}
export const ReactivateTMATTBtn = ({
  disabled = false,
  userId,
  userType,
  onDone = noop,
  onError = noop,
}: ReactivateTMATTBtnProps) => {
  const [state, { reactivateTMATT }] = useAccountActions()
  useEffect(() => {
    if (state.matches('success')) {
      onDone('LMS course successfully reactivated!')
    } else if (state.matches('failed')) {
      onError('Failed to reactivate LMS course, please try again')
    }
  }, [state, onDone, onError])
  return (
    <Button
      type="button"
      variant="buttons.outline"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 50,
      }}
      disabled={disabled || state.matches('syncing')}
      onClick={() => reactivateTMATT({ userId, userType })}>
      {state.matches('syncing') ? (
        <Loading />
      ) : (
        <span>Reactivate LMS Course</span>
      )}
    </Button>
  )
}
